import { supabase } from '@/integrations/supabase/client';
import type { EventoOS } from '@/types/ordemServico';

function normalizeDetalhes(raw: unknown): Record<string, unknown> {
  return typeof raw === 'object' && raw !== null ? (raw as Record<string, unknown>) : {};
}

export async function listEventosCliente(clienteId: string): Promise<unknown[]> {
  const { data, error } = await supabase
    .from('eventos')
    .select(`
      *,
      usuario:profiles!eventos_usuario_id_fkey(id, nome)
    `)
    .eq('cliente_potencial_id', clienteId)
    .order('criado_em', { ascending: false });

  if (error) throw error;
  return data ?? [];
}

export async function listEventosOS(ordemServicoId: string): Promise<EventoOS[]> {
  const { data, error } = await supabase
    .from('eventos_ordem_servico')
    .select(`
      *,
      usuario:profiles!eventos_ordem_servico_usuario_id_fkey(id, nome)
    `)
    .eq('ordem_servico_id', ordemServicoId)
    .order('criado_em', { ascending: false });

  if (error) throw error;

  return (data ?? []).map(e => ({
    ...e,
    detalhes: normalizeDetalhes(e.detalhes),
  })) as EventoOS[];
}
